import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { authGuard } from './guards/authGuard';
import { onboardingGuard } from './guards/onboardingGuard';
import { permissionGuard } from './guards/permissionGuard';

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(authGuard);
router.beforeEach(onboardingGuard);
router.beforeEach(permissionGuard);

export { router, routes };